// extracted by mini-css-extract-plugin
module.exports = {"sectionProductItem":"Item_sectionProductItem_2cw2c"};